import { Convert } from './Convert';

const WifiScan = require('../proto/wifi_scan_pb');
const WifiConfig = require('../proto/wifi_config_pb');
const Provisioning = require('../proto/provisioning_pb');
const textEncoder = new TextEncoder();

export class MessageHelper {
    // Send Wi-Fi Scan command
    public static prepareWiFiScanMsg(): Uint8Array {
        const configRequest = new WifiScan.CmdScanStart();
        configRequest.setBlocking(true);
        configRequest.setPassive(false);
        configRequest.setGroupChannels(0);
        configRequest.setPeriodMs(120);

        const payload = new WifiScan.WiFiScanPayload();
        payload.setMsg(WifiScan.WiFiScanMsgType.TYPECMDSCANSTART);
        payload.setCmdScanStart(configRequest);

        return payload.serializeBinary();
    }

    public static prepareGetWiFiScanStatusMsg(): Uint8Array {
        const configRequest = new WifiScan.CmdScanStatus();
        const payload = new WifiScan.WiFiScanPayload();
        payload.setMsg(WifiScan.WiFiScanMsgType.TYPECMDSCANSTATUS);
        payload.setCmdScanStatus(configRequest);

        return payload.serializeBinary();
    }

    // Get Wi-Fi scan list
    public static prepareGetWiFiScanListMsg(
        start: number,
        count: number
    ): Uint8Array {
        const configRequest = new WifiScan.CmdScanResult();
        configRequest.setStartIndex(start);
        configRequest.setCount(count);

        const payload = new WifiScan.WiFiScanPayload();
        payload.setMsg(WifiScan.WiFiScanMsgType.TYPECMDSCANRESULT);
        payload.setCmdScanResult(configRequest);

        return payload.serializeBinary();
    }

    // Send Wi-Fi Config
    public static prepareWiFiConfigMsg(
        ssid: string,
        passphrase?: string
    ): Uint8Array {
        const cmdSetConfig = new WifiConfig.CmdSetConfig();

        if (passphrase) {
            cmdSetConfig.setSsid(textEncoder.encode(ssid));
            cmdSetConfig.setPassphrase(textEncoder.encode(passphrase));
        } else {
            cmdSetConfig.setSsid(textEncoder.encode(ssid));
        }

        const wiFiConfigPayload = new WifiConfig.WiFiConfigPayload();
        wiFiConfigPayload.setCmdSetConfig(cmdSetConfig);
        wiFiConfigPayload.setMsg(
            WifiConfig.WiFiConfigMsgType.TYPECMDSETCONFIG
        );

        return wiFiConfigPayload.serializeBinary();
    }

    // Send MAC list
    public static prepareMacsConfigMsg(macs: string[]): Uint8Array {
        const arr: Uint8Array[] = new Array(macs.length);

        for (let i = 0; i < macs.length; i += 1) {
            arr[i] = Convert.hexStringToUint8Array(macs[i]);
        }

        const setMacs = new Provisioning.SetMacs();
        setMacs.setMacsList(arr);

        const wrapper = new Provisioning.Wrapper();
        wrapper.setSetMacs(setMacs);
        wrapper.setId(Provisioning.ids.PKT_SET_MAC);

        return wrapper.serializeBinary();
    }

    // Apply Wi-Fi config
    public static prepareApplyWiFiConfigMsg(): Uint8Array {
        const cmdApplyConfig = new WifiConfig.CmdApplyConfig();
        const wiFiConfigPayload = new WifiConfig.WiFiConfigPayload();
        wiFiConfigPayload.setCmdApplyConfig(cmdApplyConfig);
        wiFiConfigPayload.setMsg(
            WifiConfig.WiFiConfigMsgType.TYPECMDAPPLYCONFIG
        );

        return wiFiConfigPayload.serializeBinary();
    }

    // Get Wi-Fi Config status
    public static prepareGetWiFiConfigStatusMsg(): Uint8Array {
        const cmdGetStatus = new WifiConfig.CmdGetStatus();
        const wiFiConfigPayload = new WifiConfig.WiFiConfigPayload();
        wiFiConfigPayload.setCmdGetStatus(cmdGetStatus);
        wiFiConfigPayload.setMsg(
            WifiConfig.WiFiConfigMsgType.TYPECMDGETSTATUS
        );

        return wiFiConfigPayload.serializeBinary();
    }

    // Get Wi-Fi Config status
    public static prepareGetMacsPropagationStatusMsg(): Uint8Array {
        const propagationState = new Provisioning.GetPropagationState();
        const wrapper = new Provisioning.Wrapper();
        wrapper.setGetState(propagationState);
        wrapper.setId(Provisioning.ids.PKT_GET_STATE);

        return wrapper.serializeBinary();
    }

    public static prepareEndProvisioningMsg(
        clearSettings: boolean,
        propagateWifiPass: boolean
    ): Uint8Array {
        const cmdEndProvisioning = new Provisioning.EndProvisioning();
        cmdEndProvisioning.setClearSettings(clearSettings);
        cmdEndProvisioning.setPropagateWifiPassword(propagateWifiPass);
        const endProvisioningPayload = new Provisioning.Wrapper();
        endProvisioningPayload.setEndProv(cmdEndProvisioning);
        endProvisioningPayload.setId(Provisioning.ids.PKT_END_PROV);

        return endProvisioningPayload.serializeBinary();
    }
}
